import { TowAttempt } from '@models/tow-attempt.model';
import { createAction, props } from '@ngrx/store';

// Save Tow Attempt
export const saveTowAttemptRequest = createAction(
    '[TowAttempt] Save Tow Attempt Request',
    props<{ towAttempt: TowAttempt }>()
);
export const saveTowAttemptFailure = createAction(
    '[TowAttempt] Save Tow Attempt Failure',
    props<{ error: string }>()
);
export const saveTowAttemptSuccess = createAction(
    '[TowAttempt] Save Tow Attempt Success',
    props<{ towAttempt: TowAttempt }>()
);
